/**
 * Replaces `{key|default}` placeholders in a template string with values
 * from the provided map, falling back to the default when the key is
 * missing or empty.
 */
export const interpolate = (template: string, values: Record<string, string>): string =>
  template.replace(/\{(\w+)\|([^}]*)\}/g, (_, key: string, fallback: string) => {
    const val = values[key];
    return val && val.trim().length > 0 ? val : fallback;
  });
